module.exports = __webpack_public_path__ + "img/header-bank-square-bottom.bd84b6bf.svg";